// extracted by mini-css-extract-plugin
export default {"NavbarHolder":"BottomNavigation_NavbarHolder__sejlC","onFocus":"BottomNavigation_onFocus__f6DYw"};